export default "__VITE_ASSET__548cd852__"